import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useContext } from "react";
import NavLinkContext from "../../context/NavLinkContext";
import VideoModal from "../video-modal/VideoModal";

// assets
import footerLogo from "../../assets/images/StratCap-DIR-Logo-Reversed.png";
// import footerLogo from "../../assets/images/StratCap_Digital_Infrastructure_REIT.png";
import linkedinImg from "../../assets/images/linkedin.png";

const Footer = () => {
  const skuUrl = process.env.REACT_APP_SKU_URL;
  const [modal, setModal] = useState(false); // Controls the modal show/hide functionality with a simple boolean.
  const { setNavLinkColor } = useContext(NavLinkContext);
  const [pp, setPP] = useState(false);
  const [tou, setTOU] = useState(false);

  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);

  function renderClose() {
    setModal(false);
    setPP(false);
    setTOU(false);
  }
  return (
    <footer className="bg-hmcNavBg pt-10">
      <div className="px-7 md:px-20">
        <div className="main-margin">
          <div className="flex flex-wrap flex-col md:justify-between md:flex-row lg:mb-20">
            {/* Logo and LinkedIn */}
            <div className="mb-8 md:mb-0">
              <div className="mb-4 hidden md:block">
                <Link href="/" onClick={() => setNavLinkColor("home")}>
                  <img src={footerLogo} alt="HM Capital Logo" />
                </Link>
              </div>

              <div className="ml-[-5px]">
                <a
                  href="https://www.linkedin.com/company/stratcap/posts/?feedView=all"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={linkedinImg} alt="LinkedIn" />
                </a>
              </div>
            </div>
            {/* Navigation Links */}
            <div className="mb-8 md:mb-0">
              <ul className="space-y-2">
                <li className="text-hmcGold hover:text-hmcHoverGold">
                  <Link to="/home" onClick={() => setNavLinkColor("home")}>
                    Home
                  </Link>
                </li>
                <li className="text-hmcGold hover:text-hmcHoverGold">
                  <Link
                    to="/investments"
                    onClick={() => setNavLinkColor("investments")}
                  >
                    Investments
                  </Link>
                </li>
                <li className="text-hmcGold hover:text-hmcHoverGold">
                  <Link
                    to="/performance"
                    onClick={() => setNavLinkColor("performance")}
                  >
                    Performance
                  </Link>
                </li>
                <li className="text-hmcGold hover:text-hmcHoverGold">
                  <Link
                    to="/investorrelations"
                    onClick={() => setNavLinkColor("investorrelations")}
                  >
                    Investor Relations
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact and Info */}
            <div className="mb-8 md:mb-0 text-white">
              <ul className="space-y-2">
                <li className="font-bold">Financial Advisors</li>
                <li>
                  <a href="tel:8779071148">877-907-1148</a>
                </li>
                <li>
                  <a href="mailto:info@stratcapsecurities.com">
                    info@stratcapsecurities.com
                  </a>
                </li>
                <li>
                  <a
                    href="https://advisorportal.stratcap.com/login.aspx"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Advisor Portal Login
                  </a>
                </li>
              </ul>
            </div>

            {/* Additional Links */}
            <div className="mb-8 md:mb-0 text-white">
              <ul className="space-y-2">
                <li className="font-bold">Existing Investors</li>
                <li>
                  {" "}
                  <a
                    href="https://www.secureaccountview.com/BFWeb/clients/stratcap/index"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Click Here to login to your account
                  </a>
                </li>
              </ul>
              <ul className="mt-4 space-y-2">
                <li className="font-bold">Corporate Governance</li>
                <li>
                  <a
                    href={`${skuUrl}DIR0100`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Code of Business Conduct and Ethics
                  </a>
                </li>
                <li>
                  <a
                    href={`${skuUrl}DIR0071`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Audit Committee Charter
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="mt-10 text-xs">
            <p className="text-hmcGray-light text-base">
              Check the background of this firm on{" "}
              <a
                href="https://brokercheck.finra.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#308db8] underline"
              >
                FINRA's Broker Check
              </a>
              .
            </p>
            <p className="mt-4 text-hmcGray-light">
              StratCap Securities, LLC. is the dealer manager for the StratCap
              Digital Infrastructure REIT, Inc. offering and is a member of
              FINRA and SIPC
            </p>
            <p className="mt-4 text-hmcGray-light">
              The information provided herein is not directed at any investor or
              category of investors and is provided solely as general
              information about our products and services and to otherwise
              provide general investment education. No information contained
              herein should be regarded as a suggestion to engage in or refrain
              from any investment-related course of action as none of StratCap
              nor any of its affiliates is undertaking to provide investment
              advice, act as an adviser to any plan or entity subject to the
              Employee Retirement Income Security Act of 1974, as amended,
              individual retirement account or individual retirement annuity, or
              give advice in a fiduciary capacity with respect to the materials
              presented herein. If you are an individual retirement investor,
              contact your financial advisor or other fiduciary unrelated to
              StratCap about whether any given investment idea, strategy,
              product or service described herein may be appropriate for your
              circumstances.
            </p>
          </div>
        </div>
      </div>
      {/* Footer Bottom */}
      {/* <div className="mt-10 text-xs py-5 bg-black text-white">
        <div class="px-7 md:px-20">
          <div class="main-margin">
            <p>
              &copy; HMC Capital &nbsp;|&nbsp; Privacy Policy &nbsp;|&nbsp;
              Terms Of Use &nbsp;|&nbsp; All rights reserved
            </p>
          </div>
        </div>
      </div> */}
      {screenSize.dynamicWidth < 700 ? (
        <div className="mt-10 text-xs py-5 bg-black text-white">
          <div class="px-7 md:px-20">
            <div class="main-margin">
              <p>
                &copy; 2024 StratCap <br />
                <br />{" "}
                <span
                  onClick={() => {
                    setModal(true);
                    setPP(true);
                  }}
                >
                  Privacy Policy
                </span>{" "}
                <br />
                <span
                  onClick={() => {
                    setModal(true);
                    setTOU(true);
                  }}
                >
                  Terms Of Use
                </span>{" "}
                <br /> All rights reserved
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-10 text-xs py-5 bg-black text-white">
          <div class="px-7 md:px-20">
            <div class="main-margin">
              <p>
                &copy; 2024 StratCap &nbsp;|&nbsp;{" "}
                <span
                  onClick={() => {
                    setModal(true);
                    setPP(true);
                  }}
                  className="hover:cursor-pointer"
                >
                  Privacy Policy
                </span>{" "}
                &nbsp;|&nbsp;
                <span
                  onClick={() => {
                    setModal(true);
                    setTOU(true);
                  }}
                  className="hover:cursor-pointer"
                >
                  Terms Of Use
                </span>{" "}
                &nbsp;|&nbsp; All rights reserved
              </p>
            </div>
          </div>
        </div>
      )}
      <VideoModal show={modal} close={renderClose} pp={pp} tou={tou} />
    </footer>
  );
};

export default Footer;
